import {plural, t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {useId} from "react";

import {TextArea} from "@khanacademy/wonder-blocks-form";

import {RequestedInputLabel} from "./requested-input-label.tsx";

interface Props {
    label: string;
    value: string;
    onChange: (newValue: string) => void;
    description?: string;
    disabled?: boolean;
    required?: boolean;
    maxCharacters?: number;
    error?: string | null;
    onValidate?: (errorMessage: string | null | undefined) => void;
}

const ROWS_IN_TEXT_AREA = 3;

export const RequestedInputTextArea = ({
    label,
    value,
    onChange,
    description,
    disabled,
    required,
    maxCharacters,
    error,
    onValidate,
}: Props) => {
    const id = useId();

    const validateText: (value: string) => string | null | void = (value) => {
        if (!maxCharacters || !value || value.length <= maxCharacters) {
            return null;
        }
        return t`Uh oh! Input text is ${plural(value.length - maxCharacters, {
            one: "# character",
            other: "# characters",
        })} too long.`;
    };

    return (
        <RequestedInputLabel
            id={id}
            label={label}
            description={description}
            required={required}
            error={error}
        >
            <TextArea
                id={id}
                value={value}
                onChange={onChange}
                disabled={disabled}
                aria-details={description}
                rows={ROWS_IN_TEXT_AREA}
                required={required ? t`Must be provided` : ""}
                resizeType="vertical"
                style={styles.textArea}
                validate={validateText}
                onValidate={onValidate}
            />
        </RequestedInputLabel>
    );
};

const WB_INPUT_HEIGHT = 80;

const styles = StyleSheet.create({
    textArea: {
        minBlockSize: WB_INPUT_HEIGHT,
    },
});
